import { useMemo } from "react";

import * as z from "zod";
import { PersistedCache, PersistedCachePolicy } from "./PersistedCache";

export type UsePersistedCacheProps = {
  id: string;
  schema: z.ZodTypeAny;
  policy: PersistedCachePolicy;
};
export function usePersistedCache<T>(props: UsePersistedCacheProps) {
  return useMemo(() => {
    return new PersistedCache<T>(props.id, props.schema, props.policy);
  }, [props.id]); // We ignore policy in deps. Should only be set once.
}
